module.exports = __webpack_public_path__ + "static/media/8OLA22.3a3c7966.jpg";